<script>
import CampaignHeader from "@/components/campaignWidgets/campaignHeader";
import CampaignPlan from "@/components/campaignPlan";
import CampaignOverview from "@/components/campaignOverview";
import CampaignDetails from "@/components/campaignDetails";
import CampaignPosts from "@/components/campaignPosts";
import CampaignAttachments from "@/components/campaignAttachments";

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  components: {
    CampaignAttachments,
    CampaignPosts,
    CampaignHeader,
    CampaignPlan,
    CampaignOverview,
    CampaignDetails,
  },
  computed: {
    currentTab() {
      return this.$route.params.tab;
    },
    userType() {
      return this.$store.getters['user/userType']
    },
  },
  methods: {
    setTab(tabName) {
      if (this.currentTab === tabName) {
        return
      }

      if (this.userType === 'admin') {
        this.$router.push(`/admin/clients/${this.$route.params.clientId}/campaigns/${this.campaign._id}/${tabName}`)
      } else if (this.userType === 'client') {
        this.$router.push(`/client/campaigns/${this.campaign._id}/${tabName}`)
      }
    }
  }
}
</script>

<template>
  <div>
    <campaign-header :campaign="campaign"></campaign-header>

    <div class="row" style="min-height: 60vh">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
              <b-tab :active="!currentTab || currentTab === 'plan' " @click.prevent="setTab('plan')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Plan</span>
                </template>

                <campaign-plan :campaign="campaign"></campaign-plan>

              </b-tab>
              <b-tab :active="currentTab === 'overview' " @click.prevent="setTab('overview')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Overview</span>
                </template>

                <campaign-overview :campaign="campaign" v-if="currentTab === 'overview'"></campaign-overview>

              </b-tab>
              <b-tab :active="currentTab === 'posts'" @click.prevent="setTab('posts')" class="pt-2">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-images"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Posts</span>
                </template>

                <campaign-posts :campaign="campaign"></campaign-posts>

              </b-tab>
              <b-tab :active="currentTab === 'details'" @click.prevent="setTab('details')">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-edit"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Edit</span>
                </template>

                <campaign-details :campaign="campaign"></campaign-details>

              </b-tab>
              <b-tab :active="currentTab === 'attachments'" @click.prevent="setTab('attachments')">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-edit"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Attachments</span>
                </template>

                <div class="offset-lg-2 col-lg-8">
                  <campaign-attachments :campaign="campaign"></campaign-attachments>
                </div>

              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
